import React, { useState } from 'react';
import { FireIcon, DuplicateIcon } from '@heroicons/react/solid';

//image
import defaultPng from '../../../../../../images/default.png';

//components
import ContactDash from '../contactDash/ContactDash';

const ProfileCard = ({contact}) => {

    const [ showDash, setShowDash ] = useState(false)

    return (
        <div>
           <div className="sm:flex">
                <div className="mb-4 flex-shrink-0 sm:mb-0 sm:mr-4">
                    {contact?.contactImg !== '' ?
                        (contact?.contactImg.includes("proxycurl") ?
                        <img 
                        src={defaultPng} 
                        alt='searched' 
                        className="rounded-full p-4 h-20"
                        />
                        :
                        <img 
                        src={contact?.contactImg} 
                        alt='searched' 
                        className="rounded-full p-4 h-20"
                        />
                        )
                    :
                        <img className="rounded-full p-4 h-20" src={defaultPng} alt="" />
                    }
                </div>
                <div>
                    <h4 className="text-lg font-bold">{contact?.ProspectName}</h4>
                    <div>
                        {contact?.ProspectRole === '' && contact?.ProspectCompany === '' &&
                        contact?.Linkedin === '' && contact?.contactEducation === '' &&
                        contact?.contactFieldOfStudy === '' ?
                        <div><p className="mt-1 ml-4"><b>*custom created message</b></p></div>
                        :
                        <div className="sm:flex">
                            <div>
                                <p className="mt-1"><b>Role:</b> {contact?.ProspectRole}</p>
                                <p className="mt-1"><b>Company:</b> {contact?.ProspectCompany}</p>
                                <p className="mt-1"><b>Linkedin:</b> {contact?.Linkedin}</p>
                            </div>
                            <div className="ml-10">
                                <p className="mt-1"><b>Education:</b> {contact?.contactEducation}</p>
                                <p className="mt-1"><b>Field of study:</b> {contact?.contactFieldOfStudy}</p>
                            </div>
                        </div>
                        }
                    </div>                
                </div>
            </div>
            { !showDash ?
            <div>
                <div className='mt-4'>
                    <h2 className="text-gray-500 text-xs font-medium uppercase tracking-wide">Interest</h2>
                    <ul className="mt-3 grid grid-cols-1 gap-2 sm:gap-2 sm:grid-cols-2 lg:grid-cols-4">
                        {contact?.ProspectInterest !== '' && contact?.ProspectInterest.map((int, index) => (
                            ((int === 'Null') ? null :
                                <li key={index} className="col-span-1 flex shadow-sm rounded-md">
                                    <div className="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-lg ">
                                    <div className="flex-1 px-4 py-2 text-sm">
                                        <p className="text-gray-500">{int}</p>
                                    </div>
                                    </div>
                                </li>
                            )
                        ))}
                    </ul>
                </div>
                <div className='mt-4'>
                    <h2 className="text-gray-500 text-xs font-medium uppercase tracking-wide">Message</h2>
                    {(contact?.ProspectContent && contact?.ProspectContent !== '') ?
                    <div className="mt-4 rounded-md bg-green-50 p-4">
                        <div className="flex">
                            <div className="flex-shrink-0">
                                {(contact?.ContentCopied && contact?.ContentCopied !== '') ? <DuplicateIcon className="h-5 w-5 text-green-400" aria-hidden="true" /> : null}
                                {(contact?.ContentLiked && contact?.ContentLiked !== '') ? <FireIcon className="h-5 w-5 text-red-400" aria-hidden="true" /> : null}
                            </div>
                            <div className="ml-3">
                                <p className="text-sm font-medium text-green-800">{contact?.ProspectContent}</p>
                            </div>
                            <div className="ml-auto pl-3">
                                <div className="-mx-1.5 -my-1.5">
                                    <button
                                    type="button"
                                    className="inline-flex bg-green-50 rounded-md p-1.5 text-green-500 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600"
                                    >
                                    <span className="sr-only">interest</span>
                                    <span>{contact?.InterestUsed}</span>
                                    </button>
                                </div>
                            </div> 
                        </div>
                    </div>
                    : null}
                    <button
                        type="button"
                        className="mt-2 inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={()=> setShowDash(true)}
                    >
                        Create new message
                    </button>
                </div>
            </div>
            :
            <ContactDash setShowDash={setShowDash}/>
            }
            
        </div>
    )
}

export default ProfileCard
